export const formatAmount = (amount: string, currency: string) => {
    const { format } = new Intl.NumberFormat('en', { style: 'currency', currency });

    return format(Number(amount));
};
